import MediaFile from '@/general/models/MediaFile';
import { isPresent } from '@/shared/utils/typescript';
import Brake from './Brake';
import Tire from './Tire';

export interface TirePositionId {__positionId: number;}

export default class TirePosition {
  id!: TirePositionId;
  index = 0;
  tires: Array<Tire> = [];
  brakeMedia: Array<MediaFile> = [];
  brake!: Brake;

  isLeft(): boolean {
    return this.index < 100;
  }

  getRowIndex(): number {
    if (this.isLeft()) return this.index;
    else return this.index - 100;
  }

  getMountedTire(existing?: boolean): Tire | undefined {
    return this.tires.find(t => t.isMounted && (!existing || isPresent(t.id)));
  }

  getStoredTire(existing?: boolean): Tire | undefined {
    return this.tires.find(t => !t.isMounted && (!existing || isPresent(t.id)));
  }
}
